import React from 'react';

import classes from './BadgeDot.module.css';

const badgeDot = (props) => {
  let styleCss = props.active ? [classes.BadgeDot, classes.Active].join(' ') : classes.BadgeDot;
  let badgeTypeCss = props.small ? [styleCss, classes.BadgeDotSmall].join(' ') : styleCss;
  return (
    <figure className={badgeTypeCss} />
  );
};

export default badgeDot;
